<template>
    <div v-cloak class="manage-partner-request-widget">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Partnership Request</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                The company will automatically have access to your auto-published resources if you accept the request.
                <div class="review-section">
                    <div class="label-container">
                        <div class="label-content">
                            <div class="title">Request Details</div>
                        </div>
                    </div>
                    <div class="content-section">
                        <h2 class="label-config">Company Name</h2>
                        <div class="inline-flex">
                            <app-logo :src="logo | companyLogoPlaceholder" />
                            <div>
                                {{ companyName }}
                            </div>
                        </div>

                        <h2>Website</h2>
                        <a :href="website | addWebsiteProtocol" target="_blank">
                            {{ website }}
                        </a>

                        <h2>Contact</h2>
                        {{ contactName }}


                        <h2>Contact email</h2>
                        <a :href="`mailto:${email}`" target="_blank">
                            {{ email }}
                        </a>

                        <h2>Contact phone number</h2>
                        <a :href="`tel:${phoneNumber}`">
                            {{ phoneNumber }}
                        </a>

                        <h2>Reason for request</h2>
                        {{ requestReason }}
                    </div>
                </div>
            </div>

            <div class="widget-footer">
                <div class="action-container">
                    <app-button :disabled="isLoading" class="cancel-btn" @click="closeWidget">
                        Cancel
                    </app-button>

                    <div class="rigth-buttons">
                        <app-button :disabled="isLoading" class="deny-btn" @click="onClickDeny">
                            Deny
                        </app-button>
                        <app-button class="accept-btn" :loading="isLoading" @click="onClickAccept">
                            Accept
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template> 

<script>
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
const AppLogo = () => import('@/components/common/app-logo');
import AppPopup from '@/components/popups/app-popup';
import { PartnerApplicationService } from '@/scripts/services/partner-application/partner-application-service';
import EventBus from '@/scripts/event-bus';

export default {
    name: 'manage-partner-request-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'app-logo': AppLogo,
    },

    props: {
        widget: {
            type: Object,
            required: true
        }
    },

    data() {
        return {
            isLoading: false,
        };
    },

    computed: {
        logo() {
            return this.widget.client.logoUrl
        },

        companyName() {
            return this.widget.client.name
        },

        companyId() {
            return this.widget.client.id
        },

        contactName() {
            return this.widget.contact
        },

        website() {
            return this.widget.website
        },

        email() {
            return this.widget.email
        },

        phoneNumber() {
            return this.widget.phoneNumber
        },

        requestReason() {
            return this.widget.requestReason
        },

        idRequest() {
            return this.widget.idRequest
        },

        baseUrl() {
            return this.$store.getters.baseUrl;
        },
    },

    created() {
        EventBus.$on('deny-reason', () => {
            EventBus.$emit('partner-requests:update');
            this.closeWidget();
            this.showDeniedPopup();
        })
    },

    beforeDestroy() {
        EventBus.$off('deny-reason');
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        onClickDeny() {
            EventBus.$emit('open-widget', {
                name: 'deny-reason-widget',
                idRequest: this.idRequest,
                clientId: this.widget.client.id
            });
        },

        onClickAccept() {
            this.isLoading = true;
            PartnerApplicationService.accept({ clientId: this.companyId, applicationId: this.idRequest }).then(() => {
                this.closeWidget();
                EventBus.$emit('partner-requests:update');
                this.showSuccessPopup();
            }).catch((error) => {
                this.$helpers.showFailNotification(
                    'An error occurred while sending your request.<br/>', { error }
                );
            }).finally(() => {
                this.isLoading = false;
            })
        },

        showSuccessPopup() {

            const actions = {
                tertiary: {
                    label: 'Cancel',
                    action: () => { },
                },

                confirm: {
                    label: 'View Partnership',
                    action: () => { this.$router.push(`${this.baseUrl}/Clients`); },
                },
            };

            this.$modal.show(
                AppPopup,
                {
                    type: 'success-popup success',
                    title: 'Success',
                    content: `<p> <span style="font: normal normal bold 22px/37px Nunito;">${this.companyName}</span> has been added as a partner. To manage your partnership, please go to the Partners page.</p>`,
                    actions: actions
                },
                {
                    height: this.$helpers.setPopupHeight(),
                    width: this.$helpers.setPopupWidth(),
                }
            );
        },

        showDeniedPopup() {
            this.$modal.show(
                AppPopup,
                {
                    actions: null,
                    title: 'Partner Request Denied',
                    content: `<p> <span style="font: normal normal bold 22px/37px Nunito;">${this.companyName}</span> has been removed from your partner requests.</p>`,
                },
                {
                    height: this.$helpers.setPopupHeight(),
                    width: this.$helpers.setPopupWidth(),
                }
            );
        },
    },
}

</script>


<style>
.manage-partner-request-widget .inline-flex {
    display: inline-flex;
    gap: 10px;
    align-items: center;
}

.manage-partner-request-widget .cancel-btn {
    border: 1px solid #CAC6CB;
    border-radius: 20px;
    background: transparent;
    font: normal normal medium 14px/25px Roboto;
    letter-spacing: 0px;
    color: #382153;
    width: 127px;
    height: 40px;
}

.manage-partner-request-widget .cancel-btn:hover {
    background: #DCDCDC;
    border: 2px solid #CAC6CB;
}

.manage-partner-request-widget .deny-btn {
    width: 148px;
    height: 40px;
    background: #F30070 0% 0% no-repeat padding-box;
}

.manage-partner-request-widget .deny-btn:hover {
    background: #c3025b;
}

.manage-partner-request-widget .accept-btn {
    width: 148px;
    height: 40px;
}


.manage-partner-request-widget .rigth-buttons {
    display: flex;
    gap: 10px;
}

.manage-partner-request-widget .label-config {
    margin-top: 0;
}

.manage-partner-request-widget {
    font: normal normal normal 16px/20px Roboto;
    letter-spacing: 0px;
    color: #382153;
}

.manage-partner-request-widget h2 {
    font: normal bold 16px/24px Roboto;
    letter-spacing: 0px;
    margin-top: 25px;
}

.manage-partner-request-widget a {
    font: normal normal normal 16px/11px Roboto;
    letter-spacing: 0px;
    color: #18AEFF;
}

.manage-partner-request-widget .review-section {
    padding: 30px 60px;
    margin-top: 30px;
}

.manage-partner-request-widget .review-section .label-container {
    display: flex;
    align-items: center;
    margin: 0 auto;
    position: absolute;
    justify-content: center;
    font-weight: 600;
    left: 0;
    width: 100%;
    top: -15px;
}


.manage-partner-request-widget .review-section {
    position: relative;
    border: 2px solid #E9E9EF;
    border-radius: 22px;
    margin-bottom: 45px;
}

.manage-partner-request-widget .review-section .app-button {
    height: 30px;
    padding: 0px 15px;
    margin-left: 10px;
}

.manage-partner-request-widget .label-content {
    display: flex;
    align-items: center;
    background: #fff;
    padding: 0 20px;
}

.manage-partner-request-widget .action-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>